import { render, staticRenderFns } from "./AidNeedyFamilies.vue?vue&type=template&id=31b895f3"
import script from "./AidNeedyFamilies.vue?vue&type=script&lang=js"
export * from "./AidNeedyFamilies.vue?vue&type=script&lang=js"
import style0 from "./AidNeedyFamilies.vue?vue&type=style&index=0&id=31b895f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports